import { FieldState, FormApi } from 'final-form';
import { set } from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    props: ['form', 'label', 'name', 'emitChangeEvents', 'autoUpdate'],
    template: require('./field.html'),
})
export class Field extends Vue {
    public form: FormApi;
    public name: string;
    public bootstrapState: boolean | null = null;

    @Prop({ type: Boolean, default: false })
    public emitChangeEvents: boolean;

    // When set to true, the change event of the field will
    // automatically update the field value in the form state.
    // This is needed for fields nested in dynamic list, not to
    // loose previous unsaved modifications when an element of the list
    // is added/removed
    @Prop({ type: Boolean, default: false })
    public autoUpdate: boolean;

    public fieldState: FieldState = null as any;

    private unsubscribe;

    public created() {
        this.unsubscribe = this.form.registerField(
            this.name,
            state => {
                this.fieldState = state;
                this.bootstrapState = state.touched && !state.valid ? false : null;
                if (this.emitChangeEvents) {
                    this.$parent.$emit('field-value-changed', { name: this.name, value: state.value })
                }
            },
            {
                active: true,
                dirty: true,
                dirtySinceLastSubmit: true,
                error: true,
                initial: true,
                invalid: true,
                pristine: true,
                submitError: true,
                submitFailed: true,
                submitSucceeded: true,
                touched: true,
                valid: true,
                value: true,
                visited: true,
            },
        );
    }

    public onValueChange(value) {
        if (this.autoUpdate) {
            set(this.form.getState().values, this.name, value)
        }
        this.fieldState.change(value)
        if (this.emitChangeEvents) {
            this.$parent.$emit('field-value-changed', { name: this.name, value })
        }
    }

    public beforeDestroy() {
        requestAnimationFrame(() => this.unsubscribe());
    }

    public get sanitizedName() {
        return this.fieldState.name.replace(/[.[]/g, '-');
    }
}
